import React, { Component } from 'react'
import PropTypes from 'prop-types';
import styled from 'styled-components'
import theme from 'ui/styles/theme'
import posed, { PoseGroup } from 'react-pose'

const PosedOverlay = posed.div({
  enter: {
    opacity: 0.5
  },
  exit: {
    opacity: 0
  }
})

const OverlayContainer = styled(PosedOverlay)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${theme.colors.oxford.dark};
  opacity: 0.25;
  z-index: 4;
`

export default class Overlay extends Component {
  static propTypes = {
    active: PropTypes.bool.isRequired
  }

  render() {
    const {
      active,
      toggleNav
    } = this.props

    return(
      <PoseGroup>
        {active &&
          <OverlayContainer
            key="overlay"
            onClick={() => toggleNav()}
          />
        }
      </PoseGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/Overlay.js